import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { useFetchText } from '@lialo/common/lib/hooks/useFetchText';
import { PageDialog } from './PageDialog';

interface Props {
  component: React.ComponentType<{ content: string }>;
}

export const FetchingPageDialog = ({ component }: Props) => {
  const history = useHistory();
  const { state } = useLocation<{ pageDialog?: { title: string; url: RequestInfo } }>();

  const text = useFetchText(state?.pageDialog?.url);

  return (
    <PageDialog open={state?.pageDialog !== undefined} onBack={history.goBack} title={state?.pageDialog?.title ?? null}>
      {text && React.createElement(component, { content: text })}
    </PageDialog>
  );
};

export const useOpenFetchingPageDialog = () => {
  const history = useHistory();
  return React.useCallback(
    (args: { title: string; url: RequestInfo }) => {
      const state = history.location.state;
      const prevState = !!state && typeof state === 'object' ? state : {};
      history.push({ ...history.location, state: { ...prevState, pageDialog: args } });
    },
    [history]
  );
};
